import { Radio } from '@base-ui/react/radio';
import { RadioGroup as RadioGroupPrimitive } from '@base-ui/react/radio-group';

import { cn } from '@crm/shared/lib';

const RadioGroup = ({ className, ...props }: RadioGroupPrimitive.Props) => (
    <RadioGroupPrimitive
        data-slot="radio-group"
        className={cn('grid gap-3', className)}
        {...props}
    />
);

const RadioGroupItem = ({ className, ...props }: Radio.Root.Props) => (
    <Radio.Root
        data-slot="radio-group-item"
        className={cn(
            'group/radio-item flex size-4 shrink-0 cursor-pointer items-center justify-center rounded-full border-2 border-smtr-main-black-100 text-smtr-main-black-100 transition-colors focus-visible:ring-2 focus-visible:ring-smtr-main-accent-100 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            className
        )}
        {...props}
    >
        <Radio.Indicator
            keepMounted
            data-slot="radio-group-indicator"
            className="flex h-full w-full items-center justify-center leading-none text-smtr-main-black-100 opacity-0 transition-opacity group-hover/radio-item:opacity-100 data-checked:opacity-100"
        >
            <svg
                className="block"
                width="8"
                height="6"
                viewBox="0 0 8 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.1691 0.196446C7.46971 0.47393 7.48845 0.942566 7.21097 1.24317L3.10841 5.68762C2.96818 5.83953 2.77085 5.92593 2.56411 5.92593C2.35737 5.92593 2.16003 5.83953 2.01981 5.68762L0.196446 3.71231C-0.0810387 3.4117 -0.0622932 2.94307 0.238315 2.66558C0.538923 2.3881 1.00756 2.40684 1.28504 2.70745L2.56411 4.0931L6.12237 0.238315C6.39986 -0.0622932 6.86849 -0.0810387 7.1691 0.196446Z"
                    fill="currentColor"
                />
            </svg>
        </Radio.Indicator>
    </Radio.Root>
);

export { RadioGroup, RadioGroupItem };
